<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
        <div class="padding">
          <span class ="arch">
            <p> This is not my city. This sky is not my sky. </p>
            <br>
            <p ref="mycitya" fade="auto" speed="slow">
              You walk past, you hurry and bustle. You look at your feet and you do not look up, do not look to the sky.
              <br>Further down the hill there is a building. But there, not here. A hall with a grand entrance, horses and a eagle carved there, and I remember being inside it, watching something, a lecture?
              <br>I remember a man speaking, addressing the room, I can see the words as he spoke them to a hall full of scientists, full of inquiring faces, and I remember it was my honour to be invited to sit before that stage.
              <br>He spoke of intersects, of how he had documented them. He spoke of things we call echoes, and how they could overlap. He explained how things might become trapped, might shift from one echo to another, sometimes for a moment, sometimes longer, did he talk about people? <a @click="fade('mycitya', 'slow')">I don't remember. </a>
            </p>
            <br>
            <p>He described a tension, yes, a tension of possibility, that two echoes couldn't share a space for very long, that over time one of them would . . one of them . . I cannot remember.</p>
            <p ref="mycityb" fade="auto" speed="normal">
              That stage is absent. It should stand in that building. The colonnade that signals the entrance hall is gone. In its place is a tree-lined boulevard. I cannot see it from this spot, but I know it is there. There are no leaves on those trees, it is too early in the year for blossom. The boulevard divides water from tall brick buildings that I do not recognise. I crossed an open plaza, in which fountains threw water across stone to reach this spot. The trees are barren.
              <br>
              <br>I said that already, <a @click="fade('mycityb', 'normal')">didn't I?</a>
            </p>
            <p ref="mycityc" fade="auto" speed="fast">
              There is a voice inside my head. It isn't my voice, mine is edged with something that sounds the way I think my speech sounds in the air, it is not this voice.
              <br>I think I know what it feels like to fade
              <br>I need to something to hold on to
              <br>I say something <a @click="fade('mycityc', 'fast')"> out loud </a>
            </p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </span>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'This Is Not My City'
    }
  },
  methods: {
    fade (ref, speed) {
      this.$emit('fade', [ref, speed])
    }
  }
}
</script>

<style lang="css" scoped>
</style>
